import styles from "./Logo.module.css";

interface LogoProps {
  href: string;
}

export default function Logo({ href }: LogoProps) {
  return (
    <a href={href} className={styles.Logo}>
      <span className={styles.LogoText}>Galaxie</span> Les 2 Alpes Trail
    </a>
  );
}
